import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import CartItem from 'components/Cart/CartItem';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';

function CartItemActions({ onEditCartItem, onRemoveCartItem }) {
  return (
    <>
      <SecondaryCta
        dataTestId="cart-item-edit-button"
        label="Edit"
        handleClick={onEditCartItem}
        ownState={getOwnCartDrawerState()}
      />
      <SecondaryCta
        dataTestId="cart-item-remove-button"
        label="Remove"
        handleClick={onRemoveCartItem}
        ownState={getOwnCartDrawerState()}
      />
    </>
  );
}

CartItemActions.propTypes = {
  onEditCartItem: PropTypes.func.isRequired,
  onRemoveCartItem: PropTypes.func.isRequired
};

function CartItems({ items = [], onEditCartItem, onRemoveCartItem }) {
  return (
    <Box component={List} disablePadding data-testid="cart-items-list">
      {items.map(item => {
        const { id: itemId } = item;

        const handleEditCartItem = () => onEditCartItem(itemId);
        const handleRemoveCartItem = () => onRemoveCartItem(itemId);

        return (
          <ListItem key={itemId} disableGutters divider>
            <CartItem
              item={item}
              itemActions={
                <CartItemActions
                  onEditCartItem={handleEditCartItem}
                  onRemoveCartItem={handleRemoveCartItem}
                />
              }
            />
          </ListItem>
        );
      })}
    </Box>
  );
}

CartItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onEditCartItem: PropTypes.func.isRequired,
  onRemoveCartItem: PropTypes.func.isRequired
};

export default CartItems;
